/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Benutzer } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * BenutzerService - axios parameter creator
 * @export
 */
export const BenutzerServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Überprüft den Usernamen eines Benutzers auf Duplikate
         * @summary Prüfung, ob Benutzer exisitert
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfBenutzerNameAllreadyExists: async (username: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('checkIfBenutzerNameAllreadyExists', 'username', username)
            const localVarPath = `/api/benutzer/checkName/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Erstellt einen neuen Benutzer.
         * @summary Benutzer erstellen
         * @param {Benutzer} benutzer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBenutzer: async (benutzer: Benutzer, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'benutzer' is not null or undefined
            assertParamExists('createBenutzer', 'benutzer', benutzer)
            const localVarPath = `/api/benutzer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(benutzer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Löscht einen bestehenden Benutzer.
         * @summary Benutzer löschen
         * @param {number} id 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBenutzer: async (id: number, token: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBenutzer', 'id', id)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('deleteBenutzer', 'token', token)
            const localVarPath = `/api/benutzer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined && token !== null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sendet ein neues Passwort an Username oder E-Mail-Adresse.
         * @summary Passwort vergessen
         * @param {string} nameOrEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forget: async (nameOrEmail: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'nameOrEmail' is not null or undefined
            assertParamExists('forget', 'nameOrEmail', nameOrEmail)
            const localVarPath = `/api/benutzer/forget`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nameOrEmail !== undefined) {
                localVarQueryParameter['nameOrEmail'] = nameOrEmail;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Benutzer
         * @summary Benutzer Liste
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBenutzer: async (searchLimit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/benutzer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchLimit !== undefined) {
                localVarQueryParameter['searchLimit'] = searchLimit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert einen Benutzer
         * @summary Benutzer per Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenutzerById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBenutzerById', 'id', id)
            const localVarPath = `/api/benutzer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert einen Benutzer
         * @summary Benutzer per Name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenutzerByName: async (name: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getBenutzerByName', 'name', name)
            const localVarPath = `/api/benutzer/name/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert den aktuellen Benutzer
         * @summary aktueller Benutzer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentBenutzer: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/benutzer/currentAsList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Benutzer anhand der Suchkriterien
         * @summary Benutzersuche
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBenutzer: async (query?: string, page?: number, searchLimit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/benutzer/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (searchLimit !== undefined) {
                localVarQueryParameter['searchLimit'] = searchLimit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualisiert einen bestehenden Benutzer.
         * @summary Benutzer aktualisieren
         * @param {number} id 
         * @param {Benutzer} benutzer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBenutzer: async (id: number, benutzer: Benutzer, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBenutzer', 'id', id)
            // verify required parameter 'benutzer' is not null or undefined
            assertParamExists('updateBenutzer', 'benutzer', benutzer)
            const localVarPath = `/api/benutzer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(benutzer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BenutzerService - functional programming interface
 * @export
 */
export const BenutzerServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BenutzerServiceAxiosParamCreator(configuration)
    return {
        /**
         * Überprüft den Usernamen eines Benutzers auf Duplikate
         * @summary Prüfung, ob Benutzer exisitert
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkIfBenutzerNameAllreadyExists(username: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkIfBenutzerNameAllreadyExists(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Erstellt einen neuen Benutzer.
         * @summary Benutzer erstellen
         * @param {Benutzer} benutzer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBenutzer(benutzer: Benutzer, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Benutzer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBenutzer(benutzer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Löscht einen bestehenden Benutzer.
         * @summary Benutzer löschen
         * @param {number} id 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBenutzer(id: number, token: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBenutzer(id, token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sendet ein neues Passwort an Username oder E-Mail-Adresse.
         * @summary Passwort vergessen
         * @param {string} nameOrEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forget(nameOrEmail: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Benutzer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forget(nameOrEmail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Benutzer
         * @summary Benutzer Liste
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBenutzer(searchLimit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Benutzer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBenutzer(searchLimit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert einen Benutzer
         * @summary Benutzer per Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBenutzerById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Benutzer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBenutzerById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert einen Benutzer
         * @summary Benutzer per Name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBenutzerByName(name: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Benutzer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBenutzerByName(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert den aktuellen Benutzer
         * @summary aktueller Benutzer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentBenutzer(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Benutzer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentBenutzer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Benutzer anhand der Suchkriterien
         * @summary Benutzersuche
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBenutzer(query?: string, page?: number, searchLimit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Benutzer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchBenutzer(query, page, searchLimit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Aktualisiert einen bestehenden Benutzer.
         * @summary Benutzer aktualisieren
         * @param {number} id 
         * @param {Benutzer} benutzer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBenutzer(id: number, benutzer: Benutzer, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Benutzer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBenutzer(id, benutzer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BenutzerService - factory interface
 * @export
 */
export const BenutzerServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BenutzerServiceFp(configuration)
    return {
        /**
         * Überprüft den Usernamen eines Benutzers auf Duplikate
         * @summary Prüfung, ob Benutzer exisitert
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfBenutzerNameAllreadyExists(username: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.checkIfBenutzerNameAllreadyExists(username, options).then((request) => request(axios, basePath));
        },
        /**
         * Erstellt einen neuen Benutzer.
         * @summary Benutzer erstellen
         * @param {Benutzer} benutzer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBenutzer(benutzer: Benutzer, options?: any): AxiosPromise<Benutzer> {
            return localVarFp.createBenutzer(benutzer, options).then((request) => request(axios, basePath));
        },
        /**
         * Löscht einen bestehenden Benutzer.
         * @summary Benutzer löschen
         * @param {number} id 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBenutzer(id: number, token: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBenutzer(id, token, options).then((request) => request(axios, basePath));
        },
        /**
         * Sendet ein neues Passwort an Username oder E-Mail-Adresse.
         * @summary Passwort vergessen
         * @param {string} nameOrEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forget(nameOrEmail: string, options?: any): AxiosPromise<Benutzer> {
            return localVarFp.forget(nameOrEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Benutzer
         * @summary Benutzer Liste
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBenutzer(searchLimit?: number, options?: any): AxiosPromise<Array<Benutzer>> {
            return localVarFp.getAllBenutzer(searchLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert einen Benutzer
         * @summary Benutzer per Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenutzerById(id: number, options?: any): AxiosPromise<Benutzer> {
            return localVarFp.getBenutzerById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert einen Benutzer
         * @summary Benutzer per Name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBenutzerByName(name: string, options?: any): AxiosPromise<Benutzer> {
            return localVarFp.getBenutzerByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert den aktuellen Benutzer
         * @summary aktueller Benutzer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentBenutzer(options?: any): AxiosPromise<Array<Benutzer>> {
            return localVarFp.getCurrentBenutzer(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Benutzer anhand der Suchkriterien
         * @summary Benutzersuche
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBenutzer(query?: string, page?: number, searchLimit?: number, options?: any): AxiosPromise<Array<Benutzer>> {
            return localVarFp.searchBenutzer(query, page, searchLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualisiert einen bestehenden Benutzer.
         * @summary Benutzer aktualisieren
         * @param {number} id 
         * @param {Benutzer} benutzer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBenutzer(id: number, benutzer: Benutzer, options?: any): AxiosPromise<Benutzer> {
            return localVarFp.updateBenutzer(id, benutzer, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BenutzerService - interface
 * @export
 * @interface BenutzerService
 */
export interface BenutzerServiceInterface {
    /**
     * Überprüft den Usernamen eines Benutzers auf Duplikate
     * @summary Prüfung, ob Benutzer exisitert
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerServiceInterface
     */
    checkIfBenutzerNameAllreadyExists(username: string, options?: any): AxiosPromise<boolean>;

    /**
     * Erstellt einen neuen Benutzer.
     * @summary Benutzer erstellen
     * @param {Benutzer} benutzer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerServiceInterface
     */
    createBenutzer(benutzer: Benutzer, options?: any): AxiosPromise<Benutzer>;

    /**
     * Löscht einen bestehenden Benutzer.
     * @summary Benutzer löschen
     * @param {number} id 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerServiceInterface
     */
    deleteBenutzer(id: number, token: string, options?: any): AxiosPromise<void>;

    /**
     * Sendet ein neues Passwort an Username oder E-Mail-Adresse.
     * @summary Passwort vergessen
     * @param {string} nameOrEmail 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerServiceInterface
     */
    forget(nameOrEmail: string, options?: any): AxiosPromise<Benutzer>;

    /**
     * Liefert alle Benutzer
     * @summary Benutzer Liste
     * @param {number} [searchLimit] Search Limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerServiceInterface
     */
    getAllBenutzer(searchLimit?: number, options?: any): AxiosPromise<Array<Benutzer>>;

    /**
     * Liefert einen Benutzer
     * @summary Benutzer per Id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerServiceInterface
     */
    getBenutzerById(id: number, options?: any): AxiosPromise<Benutzer>;

    /**
     * Liefert einen Benutzer
     * @summary Benutzer per Name
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerServiceInterface
     */
    getBenutzerByName(name: string, options?: any): AxiosPromise<Benutzer>;

    /**
     * Liefert den aktuellen Benutzer
     * @summary aktueller Benutzer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerServiceInterface
     */
    getCurrentBenutzer(options?: any): AxiosPromise<Array<Benutzer>>;

    /**
     * Liefert eine Liste von Benutzer anhand der Suchkriterien
     * @summary Benutzersuche
     * @param {string} [query] Search Query
     * @param {number} [page] Page
     * @param {number} [searchLimit] Search Limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerServiceInterface
     */
    searchBenutzer(query?: string, page?: number, searchLimit?: number, options?: any): AxiosPromise<Array<Benutzer>>;

    /**
     * Aktualisiert einen bestehenden Benutzer.
     * @summary Benutzer aktualisieren
     * @param {number} id 
     * @param {Benutzer} benutzer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerServiceInterface
     */
    updateBenutzer(id: number, benutzer: Benutzer, options?: any): AxiosPromise<Benutzer>;

}

/**
 * BenutzerService - object-oriented interface
 * @export
 * @class BenutzerService
 * @extends {BaseAPI}
 */
export class BenutzerService extends BaseAPI implements BenutzerServiceInterface {
    /**
     * Überprüft den Usernamen eines Benutzers auf Duplikate
     * @summary Prüfung, ob Benutzer exisitert
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerService
     */
    public checkIfBenutzerNameAllreadyExists(username: string, options?: any) {
        return BenutzerServiceFp(this.configuration).checkIfBenutzerNameAllreadyExists(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Erstellt einen neuen Benutzer.
     * @summary Benutzer erstellen
     * @param {Benutzer} benutzer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerService
     */
    public createBenutzer(benutzer: Benutzer, options?: any) {
        return BenutzerServiceFp(this.configuration).createBenutzer(benutzer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Löscht einen bestehenden Benutzer.
     * @summary Benutzer löschen
     * @param {number} id 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerService
     */
    public deleteBenutzer(id: number, token: string, options?: any) {
        return BenutzerServiceFp(this.configuration).deleteBenutzer(id, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sendet ein neues Passwort an Username oder E-Mail-Adresse.
     * @summary Passwort vergessen
     * @param {string} nameOrEmail 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerService
     */
    public forget(nameOrEmail: string, options?: any) {
        return BenutzerServiceFp(this.configuration).forget(nameOrEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Benutzer
     * @summary Benutzer Liste
     * @param {number} [searchLimit] Search Limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerService
     */
    public getAllBenutzer(searchLimit?: number, options?: any) {
        return BenutzerServiceFp(this.configuration).getAllBenutzer(searchLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert einen Benutzer
     * @summary Benutzer per Id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerService
     */
    public getBenutzerById(id: number, options?: any) {
        return BenutzerServiceFp(this.configuration).getBenutzerById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert einen Benutzer
     * @summary Benutzer per Name
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerService
     */
    public getBenutzerByName(name: string, options?: any) {
        return BenutzerServiceFp(this.configuration).getBenutzerByName(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert den aktuellen Benutzer
     * @summary aktueller Benutzer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerService
     */
    public getCurrentBenutzer(options?: any) {
        return BenutzerServiceFp(this.configuration).getCurrentBenutzer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Benutzer anhand der Suchkriterien
     * @summary Benutzersuche
     * @param {string} [query] Search Query
     * @param {number} [page] Page
     * @param {number} [searchLimit] Search Limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerService
     */
    public searchBenutzer(query?: string, page?: number, searchLimit?: number, options?: any) {
        return BenutzerServiceFp(this.configuration).searchBenutzer(query, page, searchLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualisiert einen bestehenden Benutzer.
     * @summary Benutzer aktualisieren
     * @param {number} id 
     * @param {Benutzer} benutzer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenutzerService
     */
    public updateBenutzer(id: number, benutzer: Benutzer, options?: any) {
        return BenutzerServiceFp(this.configuration).updateBenutzer(id, benutzer, options).then((request) => request(this.axios, this.basePath));
    }
}
